import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MobileCoreModule } from '../core/mobile-core.module';
import { MobileStartFlowStore } from './store/mobile-start-flow.store';

@NgModule({
  declarations: [],
  providers: [MobileStartFlowStore],
  imports: [MatDialogModule, MobileCoreModule],
})
export class MobileStartFlowModule {
  constructor(mobileStartFlowStore: MobileStartFlowStore) {
    mobileStartFlowStore.initialize();
  }
}
